export const queryKeys = {
  cachePolicySettings: ['cache-policy-settings'],
  branchList: (uid = 'anonymous') => ['reference', 'branches', uid],
  doctorList: (uid = 'anonymous') => ['reference', 'doctors', uid],
  salespersonList: (uid = 'anonymous') => ['reference', 'salespersons', uid],
  dashboardSummary: (uid = 'anonymous') => ['dashboard', 'summary', uid],
  productRecords: ({ uid = 'anonymous', branchId = 'all', limit = 50 } = {}) =>
    ['products', 'paged', uid, branchId, limit],
  serviceRecords: ({ uid = 'anonymous', limit = 100 } = {}) =>
    ['services', 'paged', uid, limit],
  audiometryRecords: ({ uid = 'anonymous', branchId = 'all', limit = 25 } = {}) =>
    ['audiometry', 'paged', uid, branchId, limit],
  invoiceRecords: ({ uid = 'anonymous', branchId = 'all', limit = 50 } = {}) =>
    ['invoices', 'paged', uid, branchId, limit],
  invoicesPaged: ({ uid = 'anonymous', branchId = 'all', cursor = 'first', limit = 50 } = {}) =>
    ['invoices', 'paged', uid, branchId, cursor, limit],
  monthlyReportInvoices: ({ uid = 'anonymous', branchId = 'all', yearMonth = 'none' } = {}) =>
    ['invoices', 'monthly-report', uid, branchId, yearMonth],
};

export const invalidationMap = {
  invoices: ['invoices', 'monthly-report', 'dashboard'],
  products: ['products', 'inventory', 'dashboard'],
  services: ['services', 'dashboard'],
  reference_data: ['reference'],
};
